import React, { Fragment } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

const LoadingRows = () => (
  <div>
    {Array.from(new Array(4)).map(() => (
      <Fragment key={Math.random()}>
        <Skeleton height={30} />
        <Skeleton height={30} animation={false} />
        <Skeleton height={30} animation="wave" />
        {' '}
      </Fragment>
    ))}
  </div>
);

export default LoadingRows;
